// SpeakingToggleButton.jsx
import React from 'react';
import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/react/24/outline';

export default function SpeakingToggleButton({ isSpeakingMode, toggleSpeakingMode }) {
  const Icon = isSpeakingMode ? SpeakerWaveIcon : SpeakerXMarkIcon;
  const variantClasses = isSpeakingMode
    ? 'bg-green-100 text-green-800'
    : 'bg-red-100 text-red-800';
  const label = isSpeakingMode ? 'Read Mode On' : 'Read Mode Off';

  return (
    <button
      onClick={toggleSpeakingMode}
      aria-pressed={isSpeakingMode}
      className={`flex items-center mr-3 px-3 py-1 rounded-full text-sm font-medium ${variantClasses}`}
    >
      <Icon className="w-6 h-6 mr-2" />
      {label}
    </button>
  );
}
